import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import { defineStore, storeToRefs } from 'pinia';
import { apiFlushConfirm, apiGetLockVoucherList, apiGetUseVoucherList } from '@/api/voucher';
import { createUuid } from '@/utils/createUuid';
import { useLanguageStore } from '@/store/modules/language';
import { useCommonStatus } from '@/store/modules/commonStaus';
import eventBus, { COMMON_EVENT_NAME } from '@/utils/eventBus';
export const useVoucherStore = defineStore('voucher', {
  state: function () {
    return {
      voucherCenterVisible: false,
      voucherUseVisible: false,
      useVoucherVisible: false,
      useVoucherList: [],
      lockVoucherList: [],
      disabledVoucherList: [],
      // 当前不可用字段
      myVoucherList: [],
      currentNid: 0,
      currentVoucher: null,
      currentVoucherPrice: 0,
      currentPayTypeId: 0,
      isShowVoucherDrawer: false,
      tempUUid: '',
      isLoadingVoucher: false,
      nextAmount: 0,
      vipName: '',
      vipCurrency: ''
    };
  },
  actions: {
    setVoucherCenterVisible(voucherCenterVisible) {
      this.voucherCenterVisible = voucherCenterVisible;
    },
    setUseVoucherVisible(useVoucherVisible) {
      this.useVoucherVisible = useVoucherVisible;
    },
    setUseVoucherList(useVoucherList) {
      this.useVoucherList = useVoucherList;
    },
    setCurrentNid(currentNid) {
      this.currentNid = currentNid;
    },
    setCurrentVoucher(currentVoucher) {
      this.currentVoucher = currentVoucher;
    },
    // 计算最大代金券
    maxPrice(data) {
      var _this = this;
      if (this.currentPayTypeId === -101) {
        return;
      }
      let max = 100000000000000000;
      let id = 0;
      let currentVoucher = {};
      const temp = [];
      data.forEach(function (item) {
        if (item.finalAmount && Number(item.finalAmount) < max) {
          _this.currentVoucherPrice = item.finalAmount || 0;
          temp.push(item);
          id = item.id;
          currentVoucher = item;
          max = item.finalAmount;
        }
      });
      this.currentNid = id;
      this.currentVoucher = currentVoucher;
      if (!id) {
        this.currentVoucherPrice = 0;
      }
      console.log('currentVoucher', currentVoucher);
    },
    initVoucherData() {
      this.useVoucherList = [];
      this.myVoucherList = [];
      this.disabledVoucherList = [];
      this.currentVoucherPrice = 0;
      this.currentVoucher = null;
      this.currentNid = 0;
    },
    // 获取可使用的代金券列表
    async getUseVoucherList(payRegion, gameId, cpUid, serverId, amount, isUpdateGoods = true) {
      var _this2 = this;
      this.isLoadingVoucher = true;
      const res = await apiGetUseVoucherList({
        mall_game_id: gameId,
        cpUid,
        server_id: serverId,
        amount,
        payRegion
      }).finally(function () {
        _this2.isLoadingVoucher = false;
      });
      if (res.code === 0) {
        if (res.data.length > 0) {
          const result = res.data;
          const voucherTemp = [];
          const disableVoucher = [];
          const myVoucherList = [];
          result.map(function (p) {
            if (p.status === 2) {
              myVoucherList.push(p);
            }
            // 有代金券结算金额，状态是可用的，过期时间大于当前时间，才可用
            if (p.finalAmount && p.status === 2 && p.actExpiredAt > new Date().getTime()) {
              voucherTemp.push(p);
            } else {
              disableVoucher.push(p);
            }
            return true;
          });
          this.myVoucherList = myVoucherList;
          this.useVoucherList = voucherTemp;
          this.disabledVoucherList = disableVoucher;
          this.maxPrice(voucherTemp);
        } else {
          this.initVoucherData();
        }
      } else {
        this.initVoucherData();
      }
      if (isUpdateGoods) {
        eventBus.emit(COMMON_EVENT_NAME.REFRESH_GOODS_LIST);
      }
    },
    // 获取冻结的代金券
    async getLockVoucherList(params) {
      const res = await apiGetLockVoucherList({
        mall_game_id: params.mall_game_id,
        cpUid: params.cpUid,
        server_id: params.server_id
      });
      if (res.code === 0) {
        this.lockVoucherList = res.data;
      }
    },
    // 刷新是否可领取代金券代金券
    async freshVoucher(params, isOpenVoucher = true) {
      const {
        payLoadingVisible
      } = storeToRefs(useCommonStatus());
      const {
        currentCountry
      } = storeToRefs(useLanguageStore());
      const res = await apiFlushConfirm({
        mall_game_id: params.mall_game_id,
        cpUid: params.cpUid,
        server_id: params.server_id,
        payRegion: currentCountry.value.key
      });
      if (res.code === 0) {
        if (res.data.flushBenefit && !payLoadingVisible.value && isOpenVoucher) {
          this.voucherCenterVisible = true;
        }
        this.nextAmount = res.data.nextAmount;
        this.vipName = res.data.vipName;
        this.vipCurrency = res.data.currency;
      }
    },
    // 生成临时uuid
    setTempUUid(path) {
      const data = localStorage.getItem('temp_uuid_new');
      const uuid = createUuid();
      if (!data) {
        const TEMP_UUID_GAMES = {
          [path]: uuid
        };
        this.tempUUid = uuid;
        localStorage.setItem('temp_uuid_new', JSON.stringify(TEMP_UUID_GAMES));
      } else {
        try {
          const TEMP_UUID_GAMES = JSON.parse(data);
          if (!TEMP_UUID_GAMES[path]) {
            TEMP_UUID_GAMES[path] = uuid;
            localStorage.setItem('temp_uuid_new', JSON.stringify(TEMP_UUID_GAMES));
            this.tempUUid = uuid;
          } else {
            this.tempUUid = TEMP_UUID_GAMES[path];
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
  },
  persist: {
    key: '__mall_voucher_store__',
    storage: localStorage,
    paths: ['formData', 'verifyRole']
  }
});